import React from 'react'
import MainHeader from "./partials/newheader";    
import Footer from "./partials/footer";
import Gallery from './gallery';

export default function Pettipettigallery() {
  return (
    <div>
      <MainHeader />
      <Gallery />
      <Footer />
    </div>
  );
}
